import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { productTileBrandLinkPropsAdapter } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/Links/SearchProductTileBrandLinkProps";
import { DiscoveryProductTileBrandInfo, discoveryProductTileBrandInfoParamsBrandInfoPropsAdapter } from "@faire/retailer/features/MarketplaceItems/ProductDetailsTile/DiscoveryProductTileBrandInfo";
export var BrandInfo = function(param) {
    var data = param.data;
    var brandLinkProps = productTileBrandLinkPropsAdapter(data);
    if (!data) {
        return null;
    }
    return /*#__PURE__*/ _jsx(DiscoveryProductTileBrandInfo, {
        brand: discoveryProductTileBrandInfoParamsBrandInfoPropsAdapter(data),
        shouldUseClickContext: true,
        isLoggedInRetailer: data.isLoggedInRetailer,
        dataTestId: data.dataTestId,
        isLoaded: !!data,
        avgBrandReviewRating: data.avgBrandReviewRating,
        brandReviewCount: data.brandReviewCount,
        brandPromoText: data.brandPromoText,
        insiderBadgeProps: data.insiderBadgeProps,
        isHighlightedProductForPromotionalEvent: data.isHighlightedProductForPromotionalEvent,
        selectedProductOptionToken: data.selectedProductOptionToken,
        brandLinkProps: brandLinkProps
    });
};
